module.exports = __webpack_public_path__ + "static/idea-fb0a7770742e237afdc2eeb2db924ddf.svg";